export default __webpack_public_path__ + "static/media/Arch_AWS-Cloud-Trail_64.55bd8031.svg";